import { Injectable } from '@angular/core';
import { Ech0134GrundbuchmeldungSearchRequest, MeldungsEmpfaengerSearchRequest } from '../core/grundbuchmeldung-api';
import { SuchparameterService } from 'app/core/services/suchparameter.service';

@Injectable({
  providedIn: 'root'
})
export class Ech0134ModuleStateData {
  private _lastEmpfaengerSearchRequest: MeldungsEmpfaengerSearchRequest;
  private _lastMeldungSearchRequest: Ech0134GrundbuchmeldungSearchRequest;

  constructor(private suchparameterService: SuchparameterService) {}

  private resetMeldungIfneeded() {
    if (this.suchparameterService.shouldResetLastRequest()) {
      this._lastMeldungSearchRequest = null;
    }
  }

  set lastMeldungSearchRequest(value) {
    this._lastMeldungSearchRequest = value;
  }

  get lastMeldungSearchRequest() {
    this.resetMeldungIfneeded();
    return this._lastMeldungSearchRequest;
  }

  private resetEmpfaengerIfneeded() {
    if (this.suchparameterService.shouldResetLastRequest()) {
      this._lastEmpfaengerSearchRequest = null;
    }
  }

  set lastEmpfaengerSearchRequest(value) {
    this._lastEmpfaengerSearchRequest = value;
  }

  get lastEmpfaengerSearchRequest() {
    this.resetEmpfaengerIfneeded();
    return this._lastEmpfaengerSearchRequest;
  }
}
